import { render } from "./escolaInformacao.vue?vue&type=template&id=1615df3c&scoped=true"
import script from "./escolaInformacao.vue?vue&type=script&lang=js"
export * from "./escolaInformacao.vue?vue&type=script&lang=js"

import "./escolaInformacao.vue?vue&type=style&index=0&id=1615df3c&scoped=true&lang=css"
import "./escolaInformacao.vue?vue&type=style&index=1&id=1615df3c&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1615df3c"]])

export default __exports__